import vars from '@/config/vars';
import worker from '@/mocks/browser';

const enableMocking = async () => {
  if (!vars.mocks.rest && !vars.mocks.locales) {
    return null;
  }

  // print handlers
  // eslint-disable-next-line no-console
  console.group('mocks handlers');
  worker.listHandlers().forEach((handler) => {
    // eslint-disable-next-line no-console
    console.log(`[msw] ${handler.info.method} ${handler.info.path}`);
  });
  // eslint-disable-next-line no-console
  console.groupEnd();

  return worker.start({
    onUnhandledRequest: 'bypass',
  });
};

export default enableMocking;
